import React, { useState, useEffect } from 'react';
import promotionsData from './promotionsData';

const Promotions = () => {
  const [apiPromotions, setApiPromotions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch('http://127.0.0.1:8000/api/promotions');
        if (!response.ok) {
          throw new Error('Failed to fetch promotions');
        }
        const data = await response.json();
        setApiPromotions(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching promotions:', error);
        setIsLoading(false);
      }
    };

    fetchPromotions();
  }, []);

  return (
    <div className="bg-white py-8">
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold mb-4"> Promotions and available offers</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {promotionsData.map((promotion) => (
            <div
              key={promotion.id}
              className="bg-gray-200 shadow-md rounded-lg p-6 m-4 border border-gray-300"
            >
              <h2 className="text-xl font-bold mb-2">{promotion.name}</h2>
              <p className="text-gray-900 mb-4">{promotion.description}</p>
            </div>
          ))}
        </div>
        <h1 className="text-3xl font-bold mt-8 mb-4">All Promotions</h1>
        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(6)].map((_, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg p-6 m-4 border border-gray-300 animate-pulse"
              >
                <div className="h-4 bg-gray-200 mb-2"></div>
                <div className="h-4 bg-gray-200 w-5/6"></div>
                <div className="h-4 bg-gray-200 w-3/4"></div>
                <div className="h-4 bg-gray-200 w-5/6"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {apiPromotions.map((promotion) => (
              <div
                key={promotion.id}
                className="bg-white shadow-md rounded-lg p-6 m-4 border border-gray-300"
              >
                <h2 className="text-xl font-bold mb-2">{promotion.name}</h2>
                <p className="text-gray-700 mb-4">{promotion.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Promotions;
